import { call, put, takeLatest } from "redux-saga/effects";
import { dongBoApi } from "../../../api/dong-bo/dongBoApi";
import { IDongBoCongNoRequest } from "../../../model/request/dong-bo/IDongBoCongNoRequest";
import { IDongBoCongNoSinhVien } from "../../../model/respone/dong-bo/IDongBoCongNoSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import {
  eDongBoCongNoActionTypeIds,
  IDongBoCongNoActionTypes,
} from "../../action-types/dong-bo/IDongBoCongNoAction";

export function* dongBoCongNoSaga(): any {
  yield takeLatest(eDongBoCongNoActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eDongBoCongNoActionTypeIds.SYNC_START, syncWorker);
}

function* loadWorker(action: IDongBoCongNoActionTypes): any {
  const request = action.payload as IDongBoCongNoRequest;
  const res: IBaseRespone = yield call(dongBoApi.SelectCongNo, request);
  if (res.is_success) {
    var data = res.data as IDongBoCongNoSinhVien[];
    yield put(rootActions.dongBo.congNo.LOAD_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.congNo.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* syncWorker(action: IDongBoCongNoActionTypes): any {
  const request = action.payload as IProcessRequest<IDongBoCongNoRequest>;
  const res: IBaseRespone = yield call(dongBoApi.SyncCongNo, request);
  if (res.is_success) {
    var data = res.data as IDongBoCongNoSinhVien[];
    yield put(rootActions.dongBo.congNo.SYNC_SUCCESS(data));
  } else {
    yield put(rootActions.dongBo.congNo.SYNC_ERR(res.message ?? "Có lỗi"));
  }
}
